

















import MonacoEditor from 'vue-monaco';
import * as monaco from 'monaco-editor';
import { editor } from "monaco-editor";
import { es5 } from './lib.es5';
import { buffer } from './lib.buffer';
import { readings } from './lib.readings';

import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    MonacoEditor
  }
})
export default class Editor extends Vue {
  @Prop({default: "", type:String}) value!:string;
  @Prop({default: false, type:Boolean}) new?:boolean;
  @Prop({default: false, type:Boolean}) disabled!:boolean;

  editor:editor.IStandaloneCodeEditor|undefined = undefined;

  options = {
    quickSuggestions: true, 
    parameterHints: {
      enabled: true
    },
    minimap: {
      enabled: false
    },
    scrollBeyondLastLine: false
  };
  
  mounted(){
    window.addEventListener("resize", this.updateDimensions);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.editor && this.editor.layout();
  }

  async onChange(value:string){
    // await Vue.nextTick()
    // console.log(window.monaco.editor.getModelMarkers())
    // JSHINT(this.text,{esversion: '6', asi: true},{})
    // console.log(JSHINT.errors);
    this.$emit('input', value)
  }

  editorWillMount(monaco: any){

    monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
      alwaysStrict: true,
      checkJs: true,
      target: monaco.languages.typescript.ScriptTarget.ES6,
      noLib: true,
      allowNonTsExtensions: true
    });

    // Register the additional library.
    monaco.languages.typescript.javascriptDefaults.addExtraLib(es5);
    monaco.languages.typescript.javascriptDefaults.addExtraLib(buffer);
    monaco.languages.typescript.javascriptDefaults.addExtraLib(readings);

    monaco.languages.typescript.typescriptDefaults.addExtraLib(es5);
    monaco.languages.typescript.typescriptDefaults.addExtraLib(buffer);
    monaco.languages.typescript.typescriptDefaults.addExtraLib(readings);

  }

  editorDidMount(editor: any) {
    this.editor = editor;
    editor.onDidChangeModelDecorations(() => {
      this.editor && (this.$emit('updateMarkers', monaco.editor.getModelMarkers({resource: editor.getModel().uri})))
    })
    if (this.new){
      editor.onDidChangeCursorPosition((e:any)=>{
        if (e.position.lineNumber < 7) {
          this.editor && this.editor.setPosition({
            lineNumber:7,
            column: editor.getModel().getLineContent(7).length + 1
          });
        }
      });
    }
  }

  @Watch("disabled")
  async onDisabled(newValue:boolean, oldValue:boolean){

    console.log(`changing editor to read only: ${newValue}`);

    this.editor && this.editor.updateOptions({ readOnly: newValue })
  }
}
